import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import snack from '@/helpers/snack'
import serverError from '@/helpers/server_error'

export default {
  GET_GOOD_INVOICES: ({ commit, state }, payload) => {
    commit('setInvoices', [])

    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.all}`,
        {
          params: payload.params,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('updateInvoices', data.items)
          commit('setInvoiceFilters', data.filters)
          commit('setLoad', false)
          resolve(data.count)
        } else {
        }

        resolve()
      })
    })
  },
  GET_GOOD_INVOICE_STATUSES: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.status}`, {}, true).then(
        response => {
          if (response.data.result === 'success') {
            const data = response.data.data
            commit('setInvoiceStatuses', data)
          } else {
          }

          resolve()
        },
      )
    })
  },
  UPLOAD_GOOD_INVOICE: ({ commit, state }, payload) => {
    // TODO refactor to standart actions
    axios
      .post(`${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.all}`, payload.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      })
      .then(
        response => {
          if (response.data.result === 'success') {
            const item = response.data.data
            commit('prependInvoices', item)

            snack.add(payload.msgOk, 'primary')
          } else {
            snack.add(payload.msgErr)
          }
        },
        error => {
          serverError.notify(error, 'importInvoiceValidation')
        },
      )
      .finally(() => {
        commit('setLoad', false)
      })
  },
  GET_GOOD_INVOICE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.one.replace('$1', payload.item)}`,
        {
          params: {
            with: 'employer;items;items.good',
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const item = response.data.data
          commit('setInvoice', item)
          commit('setTitle', state.invoice.number)
          commit('setLoad', false)
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        resolve()
      })
    })
  },
  UPDATE_GOOD_INVOICE: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.one.replace('$1', state.invoice.id)}`,
        {
          unit_id: state.invoice.unit_id,
          company_id: state.invoice.company_id,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeInvoice', state.invoice)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  DELETE_GOOD_INVOICE: ({ commit, state, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.one.replace('$1', state.invoice.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('deleteInvoice', state.invoice.id)

          snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        const item = _.first(state.invoices)

        if (item) {
          dispatch('GET_GOOD_INVOICE', { item: item.id })
          router.push({ path: Vue.config.modules.crm.route.goodInvoices.one.replace('$1', item.id) })
        } else {
          router.push({ path: Vue.config.modules.crm.route.goodInvoices.all })
        }

        commit('setLoad', false)
        resolve()
      })
    })
  },
  UPDATE_GOOD_INVOICE_ITEM: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.item.replace('$1', payload.id)}`,
        {
          with: 'good',
          attr: {
            good_id: payload.good_id,
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeInvoiceItem', response.data.data)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  PROCESS_GOOD_INVOICE: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvoices.process.replace('$1', state.invoice.id)}`,
        {
          with: 'employer;items;items.good',
          attr: {
            unit_id: state.invoice.unit_id,
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const item = response.data.data
          commit('setInvoice', item)
          commit('changeInvoice', state.invoice)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },

  async GET_GOOD_INVOICE_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_GOOD_INVOICE', payload),
      dispatch('GET_GOOD_INVOICE_STATUSES', payload),
      dispatch('GET_GOOD_INVOICES', payload),
      dispatch('GET_UNITS'),
    ])
    commit('setLoad', false)
  },
}
